import App from './hastrid'
import main from '@shared/main';

main.CreateApp(App);